import React, { useState } from "react";
import "./MyCharters.css";

export default function MyCharters() {
  const [activeFilter, setActiveFilter] = useState("All");
  
  // Sample data for demonstration
  const charterData = [
    {
      id: 1,
      vesselName: "ASD Tug Navigator",
      vesselType: "AHTS 001",
      image: "https://res.cloudinary.com/du44pwjoi/image/upload/v1742471097/csv_klkqpb.png",
      specifications: {
        bollardPull: "48T Bollard Pull",
        paxAccommodation: "18 Pax Accommodation",
        deckSpace: "125 m² Deck Space",
        deckStrength: "577/m² Deck Strength",
        bhp: "4,200 BHP",
        classification: "Classification: ABS"
      },
      route: "Tincan port - Apapa port",
      duration: "20 Days",
      price: "$2000/Day",
      startDate: "2024-09-15",
      endDate: "2024-10-05",
      status: "Active"
    },
    {
      id: 2,
      vesselName: "MPV Atlantic Star",
      vesselType: "MPV 002",
      image: "https://res.cloudinary.com/du44pwjoi/image/upload/v1742471097/csv_klkqpb.png",
      specifications: {
        bollardPull: "48T Bollard Pull",
        paxAccommodation: "18 Pax Accommodation",
        deckSpace: "125 m² Deck Space",
        deckStrength: "577/m² Deck Strength",
        bhp: "4,200 BHP",
        classification: "Classification: ABS"
      },
      route: "Lagos - Port Harcourt",
      duration: "15 Days",
      price: "$2000/Day",
      startDate: "2024-10-10",
      endDate: "2024-10-25",
      status: "Pending"
    },
    {
      id: 3,
      vesselName: "Platform Supply Vessel",
      vesselType: "PSV 003",
      image: "https://res.cloudinary.com/du44pwjoi/image/upload/v1742471097/csv_klkqpb.png",
      specifications: {
        bollardPull: "48T Bollard Pull",
        paxAccommodation: "18 Pax Accommodation",
        deckSpace: "125 m² Deck Space",
        deckStrength: "577/m² Deck Strength",
        bhp: "4,200 BHP",
        classification: "Classification: ABS"
      },
      route: "Calabar - Bonny",
      duration: "30 Days",
      price: "$2000/Day",
      startDate: "2024-08-01",
      endDate: "2024-08-31",
      status: "Completed"
    }
  ];

  // Filter charters based on selected filter
  const filteredCharters = activeFilter === "All" 
    ? charterData 
    : charterData.filter(charter => charter.status === activeFilter);

  // Filter buttons data
  const filterButtons = [
    { name: "All", count: charterData.length },
    { name: "Active", count: charterData.filter(c => c.status === "Active").length },
    { name: "Pending", count: charterData.filter(c => c.status === "Pending").length },
    { name: "Completed", count: charterData.filter(c => c.status === "Completed").length }
  ];

  // Function to get badge class based on status
  const getBadgeClass = (status) => {
    switch(status) {
      case "Active": return "vatug-status-badge active";
      case "Pending": return "vatug-status-badge pending";
      case "Completed": return "vatug-status-badge completed";
      default: return "vatug-status-badge";
    }
  };

  // Function to handle vessel type filtering
  const handleVesselTypeFilter = (type) => {
    console.log(`Filter by vessel type: ${type}`);
    // Implementation would go here when connected to real data
  };

  return (
    <div className="my-charters-container">
      <div className="my-charters-filters">
        <div className="filter-dropdown">
          <span className="filter-icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 10H15M2.5 5H17.5M7.5 15H12.5" stroke="#667085" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Filters
          </span>
        </div>
        
        <div className="vessel-type-filters">
          {["All", "AHTS 001", "PSV 001", "SEV 001", "FSIV 001", "CSV 001"].map(type => (
            <button 
              key={type} 
              className={`vessel-type-button ${type === "All" ? "active" : ""}`}
              onClick={() => handleVesselTypeFilter(type)}
            >
              {type}
            </button>
          ))}
          <button className="vessel-type-button">Badges</button>
        </div>
      </div>

      <div className="my-charters-status-tabs">
        {filterButtons.map(filter => (
          <button 
            key={filter.name}
            className={`status-tab ${activeFilter === filter.name ? 'active' : ''}`}
            onClick={() => setActiveFilter(filter.name)}
          >
            {filter.name} ({filter.count})
          </button>
        ))}
      </div>

      <h2 className="my-charters-section-title">All Vessels ({filteredCharters.length})</h2>

      <div className="my-charters-list">
        {filteredCharters.map(charter => (
          <div className="charter-card" key={charter.id}>
            <div className="charter-image">
              <img src={charter.image} alt={charter.vesselName} />
            </div>
            
            <div className="charter-content">
              <div className="charter-header">
                <div className="charter-title">
                  <h3>{charter.vesselName}</h3>
                  <span className="charter-type">{charter.vesselType}</span>
                </div>
                <div className="charter-price">{charter.price}</div>
              </div>
              
              <div className="charter-details">
                <div className="charter-specifications">
                  <h4>Specifications</h4>
                  <ul>
                    {Object.values(charter.specifications).map((spec, index) => (
                      <li key={index}>{spec}</li>
                    ))}
                  </ul>
                </div>
                
                <div className="charter-booking-details">
                  <div className="booking-detail">
                    <span className="detail-label">Route:</span>
                    <span className="detail-value">{charter.route}</span>
                  </div>
                  <div className="booking-detail">
                    <span className="detail-label">Duration:</span>
                    <span className="detail-value">{charter.duration}</span>
                  </div>
                  <div className="booking-detail">
                    <span className="detail-label">Status:</span>
                    <span className={getBadgeClass(charter.status)}>{charter.status}</span>
                  </div>
                </div>
              </div>
              
              <div className="charter-actions">
                <button className="view-details-btn">View Details</button>
                {charter.status === "Active" && (
                  <button className="manage-charter-btn">Manage Charter</button>
                )}
                {charter.status === "Pending" && (
                  <button className="view-status-btn">View Status</button>
                )}
                {charter.status === "Completed" && (
                  <button className="renew-charter-btn">Renew Charter</button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
} 